import 'element-ui/lib/theme-chalk/index.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Vue from 'vue';
import Vuex from 'vuex';
import App from './App.vue';
import ElementUI from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import VueRouter from 'vue-router';
import routes from './routes';
import { post, get } from './common/request';
import Global from '@/common/Global.vue'
import VueClipboard from 'vue-clipboard2';
import { checkTokenExpiration, updateLastActivityTime, clearLoginInfo } from './utils/auth'
import * as auth from '@/utils/auth'


Vue.config.productionTip = false;
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$Global = Global;
Vue.prototype.$bus = new Vue();

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
Vue.use(VueRouter);
Vue.use(VueClipboard);
const router = new VueRouter({
    // mode: 'history',
    base: "/",
    routes
});

// 添加用户活动监听
const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];

activityEvents.forEach(event => {
  document.addEventListener(event, () => {
    if (localStorage.getItem('token')) {
      updateLastActivityTime();
    }
  });
});

// 定期检查token是否过期
setInterval(() => {
  if (localStorage.getItem('token')) {
    const status = checkTokenExpiration();
    if (status.expired) {
      clearLoginInfo();
      // 如果当前不在首页，才显示提示
      if (router.currentRoute.path !== '/') {
        Vue.prototype.$confirm(status.message, '提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false
        }).then(() => {
          router.push('/');
        }).catch(() => {
          router.push('/');
        });
      }
    }
  }
}, 1000 * 60); // 每分钟检查一次

// 将Vue实例保存到window对象中，以便在auth.js中使用
window._vue = new Vue({
    router,
    render: h => h(App),
}).$mount('#app')

// 将 auth 工具注册到 Vue 实例
Vue.prototype.$auth = auth
